import React, { useState } from 'react';
import {
    Box,
    Button,
    TextField,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from '@mui/material';

const CreateTerminalForm = ({ onTerminalCreated, createTerminal, merchants, existingSerialNumbers = [] }) => {
    const [merchantId, setMerchantId] = useState('');
    const [serialNumber, setSerialNumber] = useState('');
    const [model, setModel] = useState('');
    const [brand, setBrand] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const normalizedSerialNumber = serialNumber.trim().toLowerCase();
        if (existingSerialNumbers.includes(normalizedSerialNumber)) {
            setError('Ya existe una terminal con ese número de serie.');
            return;
        }

        try {
            const parsedMerchantID = merchantId !== '' ? parseInt(merchantId, 10) : null;

            await createTerminal({
                merchant_id: Number.isNaN(parsedMerchantID) ? null : parsedMerchantID,
                serial_number: serialNumber,
                model,
                brand,
                password,
                name,
                allow_update: false
            });
            onTerminalCreated();
        } catch (err) {
            setError('No se pudo crear la terminal.');
            console.error(err);
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <Typography variant="h6">Crear nueva terminal</Typography>
            {error && <Typography color="error">{error}</Typography>}
            <FormControl fullWidth margin="normal">
                <InputLabel>Comercio</InputLabel>
                <Select
                    value={merchantId}
                    onChange={(e) => setMerchantId(e.target.value)}
                    label="Comercio"
                >
                    <MenuItem value="">
                        Sin comercio
                    </MenuItem>
                    {merchants.map((merchant) => (
                        <MenuItem key={merchant.id} value={merchant.id}>
                            {merchant.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField label="Número de serie" value={serialNumber} onChange={(e) => setSerialNumber(e.target.value)} fullWidth required margin="normal" />
            <TextField label="Modelo" value={model} onChange={(e) => setModel(e.target.value)} fullWidth required margin="normal" />
            <TextField label="Marca" value={brand} onChange={(e) => setBrand(e.target.value)} fullWidth required margin="normal" />
            <TextField label="Contraseña" type="password" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth required margin="normal" />
            <TextField label="Nombre" value={name} onChange={(e) => setName(e.target.value)} fullWidth required margin="normal" />
            <Button type="submit" variant="contained" sx={{ mt: 2 }}>
                Crear
            </Button>
        </Box>
    );
};

export default CreateTerminalForm;
